<template>
  <div>
    <el-dialog
      title="管理投放渠道"
      :visible.sync="showDialog"
      width="50%"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :before-close="cancelAction"
    >
      <el-main>
        <div class="f-search-block">
          <el-form
            ref="form"
            :model="form"
            :inline="true"
          >
            <el-form-item prop="channel_name">
              <el-input
                v-model="form.channel_name"
                placeholder="请输入渠道名称"
              />
            </el-form-item>

            <el-button
              type="primary"
              @click="onSubmit"
            >
              查询
            </el-button>
            <el-button
              type="primary"
              @click="handleAdd"
            >
              添加渠道
            </el-button>
          </el-form>
        </div>
        <el-table
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            prop="channel_name"
            label="渠道名称"
            width="180"
          />
          <el-table-column
            prop="created_at"
            label="添加时间"
            width="180"
          />
          <el-table-column
            fixed="right"
            label="操作"
            width="250"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="handleCopy(scope.row)"
              >
                复制投放链接
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="handleDownload(scope.row)"
              >
                下载投放二维码
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="table-pagination"
          :current-page="form.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="form.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total_count"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </el-main>
    </el-dialog>
    <!-- 投放活动 -->
    <AddChannel
      :add-channel-visible="addChannelVisible"
      :add-channel-data="addChannelData"
      @addChannelVisibleChange="addChannelVisibleChange"
    />
  </div>
</template>

<script>
import AddChannel from '@/components/formActivity/addChannel'

export default {
  name: 'PostActivity',
  components: { AddChannel },
  props: {
    postActivityVisible: {
      type: Boolean,
      default: false
    },
    postActivityData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  data () {
    return {
      form: {
        channel_name: '',
        page: 1,
        page_size: 20
      },
      tableData: [],
      addChannelVisible: false,
      addChannelData: [false, { text: '' }],
      selectValue: [],
      activity_id: 0,
      total_count: 0
    }
  },
  computed: {
    showDialog () {
      return this.postActivityVisible
    }
  },
  watch: {
    showDialog (newVal, oldVal) {
      if (newVal) {
        this.selectValue = this.postActivityData
        this.activity_id = this.selectValue[1].item.activity_id
        this.fetch()
      } else {
        this.selectValue = []
      }
    }
  },
  created () {
    this.options = this.list
    this.codeOptions = this.codeList
  },
  methods: {
    // 列表分页
    handleSizeChange (val) {
      this.form.page = 1
      this.form.page_size = val
      this.fetch()
    },
    handleCurrentChange (val) {
      this.form.page = val
      this.fetch()
    },
    onSubmit () {
      this.form.page = 1
      this.fetch()
    },
    async fetch () {
      const params = this.form
      params.activity_id = this.activity_id
      const data = await this.$api.formActivity.listChannel(params)
      console.log(data)
      this.tableData = data.list || []
      this.total_count = data.total_count
    },
    // 关闭模态框
    cancelAction () {
      this.$emit('postActivityVisibleChange', [false])
    },
    handleAdd () {
      this.addChannelVisible = true
      this.addChannelData = [true, { activity_id: this.activity_id }]
    },
    handleConfirm () {
      let params = this.form
    },
    handleCopy (value) {
      this.$copyText(value.link).then(
        (res) => {
          return this.$message.success('复制成功')
        },
        (err) => {
          return this.$message.error('复制失败')
        }
      )
    },
    handleDownload (value) {
      this.downloadIamge(value.qrcode, value.channel_name + '.png')
    },
    addChannelVisibleChange (value) {
      if (value[0] === false) {
        this.addChannelVisible = false
        this.fetch()
      }
      if (value[1]) {
        this.addChannelData = value
        this.fetch()
      }
    },
    downloadIamge (imgsrc, name) {
      //下载图片地址和图片名
      let image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function () {
        let canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        let context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        let url = canvas.toDataURL('image/png') //得到图片的base64编码数据
        let a = document.createElement('a') // 生成一个a元素
        let event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = imgsrc + '?time=' + Date.now()
    }
  }
}
</script>

<style lang="scss" scoped>
.ml10 {
  margin-left: 10px;
}
</style>
